<template>
  <div>
    <i class="icon" :class="currentRoute.meta.icon"></i>
    <span v-show="!isCollapse">{{$t(`menu.${currentRoute.meta.title}`)}}</span>
  </div>
</template>
<script>
export default {
  name: 'MenuItem',
  props: {
    currentRoute: {
      type: Object,
      default: {}
    },
    isCollapse: {
      type: Boolean,
      default: false
    },
  },
}
</script>

<style scoped lang="scss">
.sub-el-icon {
  color: currentColor;
  width: 1em;
  height: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/menu/Item.vue